var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, Event, html, svg, classMap, State, Watch } from '@sick-davinci/ce-decorators';
import { style } from './Checkbox.style';
/**
 * A `davinci-checkbox` is a selection control that allow the user to select multiple options from a list of choices, including all or none.
 * It can be used within a `davinci-toggle-group`.
 *
 * @example
 * ```html
 *  <davinci-checkbox checked>Deactivate me</davinci-checkbox>
 * ```
 * @slot {*} label for the checkbox
 */

export let Checkbox = (_dec = Component({
  tag: 'davinci-checkbox',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Boolean), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = State(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Event(), _dec15 = Reflect.metadata("design:type", Object), _dec16 = Event(), _dec17 = Reflect.metadata("design:type", Object), _dec18 = Watch('disabled'), _dec19 = Reflect.metadata("design:paramtypes", [Object, Object]), _dec(_class = (_class2 = class Checkbox extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "checked", _descriptor, this);

    _initializerDefineProperty(this, "disabled", _descriptor2, this);

    _initializerDefineProperty(this, "error", _descriptor3, this);

    _initializerDefineProperty(this, "name", _descriptor4, this);

    _initializerDefineProperty(this, "value", _descriptor5, this);

    _initializerDefineProperty(this, "isempty", _descriptor6, this);

    _initializerDefineProperty(this, "change", _descriptor7, this);

    _initializerDefineProperty(this, "input", _descriptor8, this);

    this._mutationObserver = new MutationObserver(() => this.slotchanged());
    this._mutationObeserverParent = this;

    this.clickTrap = () => {
      this.checked = !this.checked;
      this.change.emit(this.checked);
      this.input.emit(this.checked);
    };

    this.keyTrap = event => {
      if (event.key === ' ' || event.key === 'Space') {
        this.clickTrap();
      }
    };

    this.slotchanged = () => {
      // workaround since we can not target text nodes in ::slotted to set or reset padding and host(:empty) does not work on ShadyCSS
      if (this.textContent) {
        this.isempty = false;
      } else {
        this.isempty = true;
      }
    };

    this._storedTabindex = 0;
  }

  componentConnected() {
    this.addEventListener('click', this.clickTrap);
    this.addEventListener('keyup', this.keyTrap);
  }

  componentFirstRender() {
    this.slotchanged();

    if (window.ShadyDOM) {
      // tslint:disable-line
      // workaround for shadydom (in ie and old edge)
      // otherwise we'll also get mutation updates in the shadowdom (which we don't want)
      this._mutationObeserverParent = this.shadowRoot.querySelector('#compatibility-slot');
    }

    this._mutationObserver.observe(this._mutationObeserverParent, {
      attributes: false,
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  componentDisconnected() {
    this.removeEventListener('click', this.clickTrap);
    this.removeEventListener('keyup', this.keyTrap);
  } // The tab-index before it was altered by _updateTabIndex()


  /**
   * Updates the tab-index of this check-box.
   *
   * This function will probably be removed once 'delegatesFocus:true' is used when creating the shadow DOM.
   * @private
   */
  _updateTabIndex() {
    const currentTabIndex = this.tabIndex;

    if (currentTabIndex !== -1) {
      this._storedTabindex = currentTabIndex;
    }

    if (this.disabled) {
      // A tab-index of -1 prevents the browser from focusing this check-box when the TAB-key is hit.
      this.tabIndex = -1;
    } else if (!this.hasAttribute('tabindex')) {
      // The check-box cannot be focused via TAB-key if no tab-index is present.
      this.tabIndex = this._storedTabindex;
    } else {
      // Restore the old tab-index
      this.tabIndex = this._storedTabindex;
    }
  }

  disabledChangeHandler(_oldValue, _newValue) {
    this._updateTabIndex();
  }

  componentDidRender() {
    this._updateTabIndex();
  }

  render() {
    return html`
    <div class="wrapper">
    <div class="cb_box">
      ${svg`
      <svg width="22px" height="22px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1">
          <g>
            <polygon points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"></polygon>
          </g>
        </g>
      </svg>`}
    </div><div id="compatibility-slot" class="${classMap({
      cb_label: true,
      empty: this.isempty
    })}">
      <slot></slot>
    </div>
    </div>
    `;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "checked", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "error", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "isempty", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "disabledChangeHandler", [_dec18, _dec19], Object.getOwnPropertyDescriptor(_class2.prototype, "disabledChangeHandler"), _class2.prototype)), _class2)) || _class);
